import { render, staticRenderFns } from "./DoctorSelector.vue?vue&type=template&id=67eff6f4&"
import script from "./DoctorSelector.vue?vue&type=script&lang=ts&"
export * from "./DoctorSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports